import React from "react";
import LinkedAccountsPageData from "./LinkedAccountPageData";
import PortalPageHeaderWrapper from "../../portal/PortalPageHeaderWrapper";
import CreateLinkedAccountButton from "./CreateLinkedAccountButton";
import { PROD_LINKED_ACCOUNTS_PATH, TEST_LINKED_ACCOUNTS_PATH } from "../../../router/RouterUtils";
import { LinkedAccount } from "../../../models/Entities";

type Props = {
  isTestAccounts: boolean;
  linkedAccounts: LinkedAccount[] | undefined;
  hasNext: boolean;
  hasPrevious: boolean;
  onNext: () => void;
  onPrevious: () => void;
  onRemove: (index: number) => void;
  onRefetch: (cursor?: any) => void;
  isLoading: boolean;
  onLinkedAccountsParamsPathChange: (paramsPath: string) => void;
};

const LinkedAccountsPage = (props: Props) => {
  return (
    <PortalPageHeaderWrapper
      title="Linked Accounts"
      subtitle="Integrations between your users' accounts and third-party platforms"
      subtabs={[
        { label: "Production", destination: PROD_LINKED_ACCOUNTS_PATH },
        { label: "Test", destination: TEST_LINKED_ACCOUNTS_PATH },
      ]}
      buttons={<CreateLinkedAccountButton />}
    >
      <LinkedAccountsPageData {...props} />
    </PortalPageHeaderWrapper>
  );
};

export default LinkedAccountsPage;
